//@flow

import * as React from 'react';
import DropzoneArea from 'react-dropzone';
import styled from 'styled-components';
import { translate } from "react-i18next";
import {
    PHOTOS_TYPE,
    VIDEO_TYPE,
    SHP_TYPE,
    ORTO_TYPE,
    DRONE_TYPE,
    RESOURCE_TYPE
} from '../../../../../types/upload';

const DropzoneWrapper = styled.div`
  width: 100%;
  height: 55px; 
  padding: 10p;
  margin-bottom: 10px;
`

const StyledDropzoneLabel = styled.div`
  white-space: normal;
  text-align: center;
`;

const getTypeSettings = (loadType, t) => {
    switch (loadType) {
        case PHOTOS_TYPE:
            return {
                message: t('Drop photos'),
                acceptedTypes: 'image/*'
            }
        case VIDEO_TYPE:
            return {
                message: t('Drop video'),
                acceptedTypes: 'video/*'
            }
        case SHP_TYPE:
            return {
                message: t('Drop zip file'),
                acceptedTypes: '.zip'
                //acceptedTypes: '.shp, .shx, .dbf, .prj, .sbn, .sbx, .shp.xml, .cpg'
            }
        case ORTO_TYPE:
            return {
                message: t('Drop geotiff file'),
                acceptedTypes: '.tif, .tiff'
            }
        case DRONE_TYPE:
            return {
                message: t('Drop log file'),
                acceptedTypes: '.txt'
            }
        case RESOURCE_TYPE:
        default:
            return {
                message: t('Drop file'),
            }
    }
};

const Dropzone = (props) => {
    const {
        onLoad,
        loadType,
        t,
        disabled
    } = props;

    const { message, acceptedTypes } = getTypeSettings(loadType, t);

    return (
        <DropzoneWrapper>
            <DropzoneArea
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px dashed #265a9c',
                    backgroundColor: '#ffffff',
                    color: '#265a9c',
                    cursor: 'pointer',
                }}
                activeStyle={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid #265a9c',
                }}
                acceptStyle={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid green'
                }}
                rejectStyle={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid red',
                }}
                multiple={(loadType === PHOTOS_TYPE)}
                accept={acceptedTypes}
                onDrop={(files: Array<File>) => {
                    onLoad(files);
                }}
                disabled={disabled}
            >
                <StyledDropzoneLabel>
                    {message}
                    <br />
                    {t('or click to browse files')}
                </StyledDropzoneLabel>
            </DropzoneArea >
        </DropzoneWrapper>
    );
};

export default translate("translations")(Dropzone);


// WEBPACK FOOTER //
// ./src/containers/content/grid/uploadPanel/dropzone/Dropzone.jsx